import { z } from "zod";

import {
  CreateOrganizationInquiryDtoAdvertiseEvents,
  CreateOrganizationInquiryDtoDiverseTalent,
  CreateOrganizationInquiryDtoErgInterests,
  CreateOrganizationInquiryDtoHearFormUs,
  CreateOrganizationInquiryDtoIsErgMember,
  CreateOrganizationInquiryDtoNumberOfEmployees,
  CreateOrganizationInquiryDtoReachTo,
  CreateOrganizationInquiryDtoVacancies,
} from "@/src/hooks/api/generated";

export const becomeACorporateMemberSchema = z
  .object({
    advertise_events: z.nativeEnum(
      CreateOrganizationInquiryDtoAdvertiseEvents,
      {
        required_error: "Please select advertisement event",
      }
    ),
    contact_number: z
      .string()
      .min(1, { message: "Required." })
      .max(35, { message: "Must be at most 35 characters." })
      .regex(/^[+\d]?(?:[\d-.\s()]*)$/, { message: "Invalid phone number." }),
    location: z.string().min(1, { message: "Location is required." }),
    diverse_talent: z.nativeEnum(CreateOrganizationInquiryDtoDiverseTalent, {
      required_error: "Please select diverse talent",
    }),
    email: z
      .string()
      .min(1, {
        message: "Please Enter Your Email",
      })
      .email({ message: "Invalid email address." }),
    first_name: z.string().min(1, { message: "First name is required." }),
    last_name: z.string().min(1, { message: "Last name is required." }),
    hear_form_us: z
      .nativeEnum(CreateOrganizationInquiryDtoHearFormUs)
      .optional(),
    job_title: z.string().min(1, { message: "Required." }),
    number_of_employees: z.nativeEnum(
      CreateOrganizationInquiryDtoNumberOfEmployees,
      {
        required_error: "Please select number of employees",
      }
    ),
    organization_name: z.string().min(1, { message: "Required." }),
    reach_to: z.nativeEnum(CreateOrganizationInquiryDtoReachTo, {
      required_error: "Please select a value for who you would like to reach.",
      invalid_type_error: "Please select at least 1 value.",
    }),
    vacancies: z.nativeEnum(CreateOrganizationInquiryDtoVacancies, {
      required_error: "Please select vacancies.",
    }),
    privacyPolicy: z.boolean().refine((val) => val === true, {
      message: "Please Accept The Privacy Policy",
    }),
    is_erg_member: z.nativeEnum(CreateOrganizationInquiryDtoIsErgMember, {
      required_error: "Please select employee resource group (ERG)",
    }),
    erg_interests: z
      .nativeEnum(CreateOrganizationInquiryDtoErgInterests)
      .optional(),
  })
  .refine(
    (data) =>
      data.is_erg_member === "No" ||
      (data.is_erg_member === "Yes" && !!data.erg_interests),
    {
      message: "Please select accessing.",
      path: ["erg_interests"],
    }
  );

export type BecomeACorporateMemberSchemaType = z.infer<
  typeof becomeACorporateMemberSchema
>;
